var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.305 15.712a1.031 1.031 0 0 0 1.458 0L12 10.475l5.237 5.237a1.031 1.031 0 0 0 1.459-1.458l-5.967-5.966a1.031 1.031 0 0 0-1.458 0l-5.966 5.966a1.031 1.031 0 0 0 0 1.458Z",
    fill: "currentColor"
  })));
};
export default SvgChevronUp;